import React, { Fragment, useEffect } from "react";
import {
    Card,
    Col,
    Row,
} from "reactstrap";
import './style.scss';
import { connect } from "react-redux";
import { getDashboardData } from "../../store/dashboard/actions";
import { Link } from "react-router-dom";
import { TECHNICIAN, CUSTOMER, MANUFACTURER } from "../../store/users/role.constants";
import VWLoading from "../../components/vwLoading/vwLoading";


const iconAlign = "position-absolute top-0 start-50 translate-middle border border-transparent border-5"

const DashboardCards = (props) => {
    const { dashboardData, isDashboardDataPending, currentProfile } = props;
    const { usersCount, unAssignedDevicesCount, assignedDevicesCount, isActiveDeviceCount, inActiveDeviceCount } = dashboardData || {};
    const isEndUser = currentProfile.roles && currentProfile.roles.length > 0 &&
        currentProfile.roles[0].roleKey === CUSTOMER;
    const isTechnician = currentProfile.roles && currentProfile.roles.length > 0 &&
        currentProfile.roles[0].roleKey === TECHNICIAN;
    const isManufacturer = currentProfile.roles && currentProfile.roles.length > 0 &&
        currentProfile.roles[0].roleKey === MANUFACTURER;
    useEffect(() => {
        props.getDashboardData();
    }, [])

    return (
        <Fragment>
            {isDashboardDataPending ?
                <div className="d-flex justify-content-center">
                    {/* <VWSpinner /> */}
                    <VWLoading />
                </div> :
                <Card className="py-4 shadow-none" color="transparent" >
                    <Row className=" responsive-card d-flex justify-content-around ">
                        {!(isEndUser || isTechnician || isManufacturer) &&
                            <Col xl='2' md='4' sm='12' className="pb-5">
                                <Link to='/userlist' className="text-white">
                                    <Card style={{ backgroundColor: "#224193" }}>
                                        <div className='d-grid mb-2 position-relative'>
                                            <div className={`${iconAlign} mb-0 icon-area-1`}>
                                                <i className="fas fa-users"></i>
                                            </div>
                                            <div className="position-relative top-50 start-50 translate-middle pt-5">
                                                <div className="text-center fs-5 fw-bolder">{usersCount || 0}</div>
                                                <div className="text-center fs-6 fw-bolder">USERS</div>
                                            </div>
                                        </div>
                                    </Card>
                                </Link>
                            </Col>}
                        {!(isEndUser || isTechnician) &&
                            <Col xl={!(isEndUser || isTechnician || isManufacturer) ? '2' : '2'} md='4' sm='12' className="pb-5">
                                <Link to='/devicelist' state={{ assignedStatus: 'unassigned' }} className="text-white">
                                    <Card style={{ backgroundColor: "#ed6f63" }}>
                                        <div className='d-grid mb-2 position-relative'>
                                            <div className={`${iconAlign} mb-0 icon-area-2`}>
                                                <i className="fas fa-hdd"></i>
                                            </div>
                                            <div className="position-relative top-50 start-50 translate-middle  pt-5">
                                                <div className="text-center fs-5 fw-bolder">{unAssignedDevicesCount || 0}</div>
                                                <div className="text-center fs-6 fw-bolder">UNASSIGNED DEVICES</div>
                                            </div>
                                        </div>
                                    </Card>
                                </Link>
                            </Col>
                        }
                        <Col xl={!(isEndUser || isTechnician || isManufacturer) ? '2' : '2'} md='4' sm='12' className="pb-5">
                            <Link to='/devicelist' state={{ assignedStatus: 'assigned' }} className="text-white">
                                <Card style={{ backgroundColor: "#2BAE66" }}>
                                    <div className='d-grid mb-2 position-relative'>
                                        <div className={`${iconAlign} mb-0 icon-area-3`}>
                                            <i className="fas fa-server"></i>
                                        </div>
                                        <div className="position-relative top-50 start-50 translate-middle  pt-5">
                                            <div className="text-center fs-5 fw-bolder">{assignedDevicesCount || 0}</div>
                                            <div className="text-center fs-6 fw-bolder">ASSIGNED DEVICES</div>
                                        </div>
                                    </div>
                                </Card>
                            </Link>
                        </Col>
                        <Col xl={!(isEndUser || isTechnician || isManufacturer) ? '2' : '2'} md='4' sm='12' className="pb-5">
                            <Link to='/devicelist' state={{ activeStatus: 'active' }} className="text-white">
                                <Card style={{ backgroundColor: "#141E46" }}>
                                    <div className='d-grid mb-2 position-relative'>
                                        <div className={`${iconAlign} mb-0 icon-area-4`}>
                                            <i className="fas fa-server"></i>
                                        </div>
                                        <div className="position-relative top-50 start-50 translate-middle  pt-5">
                                            <div className="text-center fs-5 fw-bolder">{isActiveDeviceCount || 0}</div>
                                            <div className="text-center fs-6 fw-bolder">ACTIVE DEVICES</div>
                                        </div>
                                    </div>
                                </Card>
                            </Link>
                        </Col>
                        <Col xl={!(isEndUser || isTechnician || isManufacturer) ? '2' : '2'} md='4' sm='12' className="pb-5">
                            <Link to='/devicelist' state={{ activeStatus: 'inactive' }} className="text-white">
                                <Card style={{ backgroundColor: "#8644A2" }}>
                                    <div className='d-grid mb-2 position-relative'>
                                        <div className={`${iconAlign} mb-0 icon-area-5`}>
                                            <i className="fas fa-server"></i>
                                        </div>
                                        <div className="position-relative top-50 start-50 translate-middle  pt-5">
                                            <div className="text-center fs-5 fw-bolder">{inActiveDeviceCount || 0}</div>
                                            <div className="text-center fs-6 fw-bolder">INACTIVE DEVICES</div>
                                        </div>
                                    </div>
                                </Card>
                            </Link>
                        </Col>
                    </Row>
                </Card>
            }
        </Fragment >
    )
}

const mapStateToProps = (state) => ({
    dashboardData: state.dashboard.dashboardData,
    isDashboardDataPending: state.dashboard.isDashboardDataPending,
    currentProfile: state.login.currentProfile,

})

const mapDispatchToProps = (dispatch) => ({
    getDashboardData: () => dispatch(getDashboardData()),
})
export default connect(mapStateToProps, mapDispatchToProps)(DashboardCards);